import { useState, useEffect } from 'react';
import { subscriptionApi } from '@/services/api';
import type { Plan } from '@/types';
import PublicHeader from '@/components/layout/PublicHeader';
import LandingFooter from '@/components/landing/LandingFooter';
import PricingSection from '@/components/landing/PricingSection';
import { usePageSEO } from '@/hooks/usePageSEO';
import { useTranslation } from 'react-i18next';

export default function PricingPage() {
  const { t } = useTranslation();
  const [plans, setPlans] = useState<Plan[]>([]);
  const [isLoadingPlans, setIsLoadingPlans] = useState(true);

  usePageSEO('pricing', { canonicalPath: '/pricing', breadcrumbs: [{ name: 'Pricing' }] });

  useEffect(() => {
    const fetchPlans = async () => {
      try {
        const response = await subscriptionApi.getPlans();
        setPlans(response.data);
      } catch (error) {
        console.error('Failed to fetch plans:', error);
      } finally {
        setIsLoadingPlans(false);
      }
    };

    fetchPlans();
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 font-sans selection:bg-primary-200 selection:text-primary-900 dark:selection:bg-primary-900/50 dark:selection:text-primary-100">
      <PublicHeader />

      {/* Spacer for the fixed header — see PUBLIC_HEADER_HEIGHT_PX */}
      <div className="pt-28" />

      {/* PricingSection's own heading is an h2 (it's also reused as a section
          on LandingPage, which already has its own h1) — this page needs its
          own h1 for document structure and SEO, without visually duplicating
          the h2 immediately below it. */}
      <h1 className="sr-only">{t('seo.pricing.title')}</h1>

      <PricingSection plans={plans} isLoading={isLoadingPlans} showComparison={true} />

      <LandingFooter />
    </div>
  );
}
